import React, { useState } from 'react';
import AdminButton from '../../../Admin/components/AdminButton';
import { AdminFormField, AdminTextInput } from '../../../Admin/components/AdminFormField';
import ConfigDrawer from './ConfigDrawer';

interface ConfigNameDrawerProps {
  title: string;
  subtitle?: string;
  label: string;
  initial?: string;
  onClose: () => void;
  onSave: (name: string) => void;
}

/** Single-name add/edit drawer (focus areas). Save stays disabled until the name is non-empty and changed. */
const ConfigNameDrawer: React.FC<ConfigNameDrawerProps> = ({
  title,
  subtitle,
  label,
  initial = '',
  onClose,
  onSave,
}) => {
  const [name, setName] = useState(initial);
  const trimmed = name.trim();
  return (
    <ConfigDrawer
      title={title}
      subtitle={subtitle}
      onClose={onClose}
      footer={
        <>
          <AdminButton label="Cancel" variant="secondary" onPress={onClose} />
          <AdminButton
            label="Save"
            variant="primary"
            disabled={!trimmed || trimmed === initial}
            onPress={() => onSave(trimmed)}
          />
        </>
      }
    >
      <AdminFormField label={label} required>
        <AdminTextInput value={name} maxLength={40} onChangeText={setName} />
      </AdminFormField>
    </ConfigDrawer>
  );
};

export default ConfigNameDrawer;
